import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import CircularProgress from '@material-ui/core/CircularProgress';
import SendIcon from '@material-ui/icons/Send';

const useStyles = makeStyles(() => ({
  campo: {
    width: '100%',
    marginBottom: '15px'
  }
}));

/** Para, Asunto y Mensaje del envío por mail. mail: lo que devuelve useMailComprobante. */
export const MailComprobanteCampos = ({ mail }) => {
  const classes = useStyles();

  return (
    <React.Fragment>
      <TextField
        className={classes.campo}
        label="Para"
        value={mail.destinatarios}
        onChange={(event) => mail.setDestinatarios(event.target.value)}
        error={mail.errorDestinatarios}
        helperText={mail.ayudaDestinatarios}
        disabled={mail.enviando}
        InputProps={{ endAdornment: mail.cargandoMails ? <CircularProgress size={16} /> : null }}
      />
      <TextField
        className={classes.campo}
        label="Asunto"
        value={mail.asunto}
        onChange={(event) => mail.setAsunto(event.target.value)}
        error={mail.asunto.trim() === ''}
        disabled={mail.enviando}
      />
      <TextField
        className={classes.campo}
        label="Mensaje"
        value={mail.mensaje}
        onChange={(event) => mail.setMensaje(event.target.value)}
        multiline
        rows={6}
        variant="outlined"
        disabled={mail.enviando}
      />
    </React.Fragment>
  );
};

/** Enviar y Cancelar del envío por mail. */
export const MailComprobanteAcciones = ({ mail, onCancelar }) => (
  <React.Fragment>
    <Button
      color="primary"
      variant="contained"
      startIcon={mail.enviando ? <CircularProgress size={16} color="inherit" /> : <SendIcon />}
      disabled={!mail.puedeEnviar}
      onClick={mail.enviar}
    >
      {mail.enviando ? 'Enviando...' : 'Enviar'}
    </Button>
    <Button onClick={onCancelar} disabled={mail.enviando}>
      Cancelar
    </Button>
  </React.Fragment>
);
